import React from 'react';
import autotintinstall from '../../assets/autotintinstall.jpg';

export const ShopHero = () => {
  return (
    <div className="relative text-white overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ 
          backgroundImage: `url(${autotintinstall})`,
          opacity: 0.9
        }}
      />
      <div className="absolute inset-0 bg-black/80" />
      
      <div className="container mx-auto px-4 py-16 relative z-10">
        <div className="max-w-3xl">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Līmē Pats!</h1>
          <p className="text-xl mb-8 text-gray-300">
            Profesionālas plēves tavam auto un mājoklim. Izbaudi kvalitāti par saprātīgu cenu ar 5 gadu garantiju visiem materiāliem.
          </p>
          <div className="space-x-4">
            <a 
              href="#automotive" 
              className="inline-block bg-green-400 hover:bg-green-600 text-black px-6 py-3 rounded-md font-semibold transition-colors"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('automotive')?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              Auto Plēves
            </a>
            <a 
              href="#residential" 
              className="inline-block bg-white hover:bg-gray-200 text-black px-6 py-3 rounded-md font-semibold transition-colors"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('residential')?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              Mājokļu Plēves
            </a>
          </div>
        </div>
      </div>
      
      {/* Features section */}
      <div className="border-t border-gray-800 relative z-10">
        <div className="container mx-auto px-4 py-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="flex items-center space-x-4">
              <div className="bg-green-400 p-3 rounded-full">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-black" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <div>
                <h3 className="font-semibold">Augsta Kvalitāte</h3>
                <p className="text-sm text-gray-400">Tikai profesionāli materiāli</p>
              </div>
            </div>
            <div className="flex items-center space-x-4">
              <div className="bg-green-400 p-3 rounded-full">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-black" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div>
                <h3 className="font-semibold">Ātra Piegāde</h3>
                <p className="text-sm text-gray-400">1-3 dienas visā Latvijā</p>
              </div>
            </div>
            <div className="flex items-center space-x-4">
              <div className="bg-green-400 p-3 rounded-full">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-black" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
              </div>
              <div>
                <h3 className="font-semibold">Palīgs Īsziņas Attālumā</h3>
                <p className="text-sm text-gray-400">Aplīmēšanas palīdzība rakstot WhatsApp</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}; 